module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/addeditsubmenu/addeditsubmenu.component.css
// module id = ./src/app/addeditsubmenu/addeditsubmenu.component.css
// module chunks = main